<template>
  <div v-if="isOpen" class="relative z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background backdrop -->
    <div class="fixed inset-0 bg-slate-500/75 dark:bg-slate-900/80 transition-opacity backdrop-blur-sm" @click="$emit('close')"></div>

    <div class="fixed inset-0 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
          
          <!-- Slide-over panel -->
          <div class="pointer-events-auto w-screen max-w-md transform transition-transform duration-500 sm:duration-700">
            <div class="flex h-full flex-col overflow-y-scroll bg-white dark:bg-slate-800 shadow-2xl py-6">
              
              <div class="px-4 sm:px-6">
                <div class="flex items-start justify-between">
                  <h2 class="text-xl font-semibold leading-6 text-slate-900 dark:text-white" id="slide-over-title">{{ pipeline?.name }} Details</h2>
                  <div class="ml-3 flex h-7 items-center">
                    <button type="button" class="relative rounded-md text-slate-400 hover:text-slate-500 focus:outline-none" @click="$emit('close')">
                      <span class="absolute -inset-2.5"></span>
                      <span class="sr-only">Close panel</span>
                      <Icon name="heroicons:x-mark" class="h-6 w-6" />
                    </button>
                  </div>
                </div>
              </div>

              <div class="relative mt-6 flex-1 px-4 sm:px-6">
                <!-- Content -->
                <div class="space-y-6">
                    
                    <!-- Header Info -->
                    <div class="flex items-center space-x-4 p-4 bg-slate-50 dark:bg-slate-700/50 rounded-lg">
                        <div class="w-12 h-12 flex items-center justify-center bg-white dark:bg-slate-600 rounded-lg shadow-sm">
                             <!-- Using generic helper if available or passing icon name logic down is better, for now simple fallback -->
                             <Icon :name="'heroicons:cube'" class="w-8 h-8 text-slate-500 dark:text-slate-300" />
                        </div>
                        <div>
                            <div class="text-sm font-medium text-slate-500 dark:text-slate-400">{{ pipeline?.appName }}</div>
                            <div class="text-lg font-bold text-slate-900 dark:text-white">{{ pipeline?.taskType === 'ingestion' ? 'Ingestion Pipeline' : 'Dispatch Pipeline' }}</div>
                        </div>
                    </div>

                    <!-- Config / Meta -->
                    <div>
                        <h3 class="text-sm font-semibold text-slate-900 dark:text-white mb-2">Configuration</h3>
                        <dl class="divide-y divide-slate-100 dark:divide-slate-700 text-sm">
                            <div class="py-2 flex justify-between">
                                <dt class="text-slate-500">Pipeline ID</dt>
                                <dd class="font-mono text-slate-700 dark:text-slate-300">{{ pipeline?.id }}</dd>
                            </div>
                            <div class="py-2 flex justify-between">
                                <dt class="text-slate-500">Schedule</dt>
                                <dd class="text-slate-700 dark:text-slate-300">Every 15 minutes</dd>
                            </div>
                            <div class="py-2 flex justify-between">
                                <dt class="text-slate-500">Destination</dt>
                                <dd class="text-slate-700 dark:text-slate-300 font-mono">RAW_DATA.{{ pipeline?.appName.toUpperCase() }}</dd>
                            </div>
                        </dl>
                    </div>

                    <!-- Recent Logs (Mock) -->
                    <div>
                        <h3 class="text-sm font-semibold text-slate-900 dark:text-white mb-3">Recent Execution Logs</h3>
                        <div class="space-y-3">
                            <div v-for="i in 3" :key="i" class="flex space-x-3 text-xs">
                                <div class="flex-shrink-0 w-16 text-slate-400 font-mono text-right">10:{{ 45 - (i*15) }} AM</div>
                                <div class="flex-1 space-y-1 pb-3 border-b border-slate-100 dark:border-slate-700 last:border-0">
                                    <div class="flex items-center">
                                        <span class="w-2 h-2 rounded-full mr-2" :class="i === 1 && pipeline?.status === 'ERROR' ? 'bg-red-500' : 'bg-green-500'"></span>
                                        <span class="font-medium text-slate-700 dark:text-slate-300">
                                            {{ i === 1 && pipeline?.status === 'ERROR' ? 'Sync Failed: API Timeout' : 'Sync Completed Successfully' }}
                                        </span>
                                    </div>
                                    <div class="text-slate-500 pl-4">Processed 450 records in 2.4s</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean
  pipeline: any
}>()

defineEmits(['close'])
</script>
